import { useState, useCallback } from "react";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

/**
 * Hook para manejar la lógica de escaneo de QR
 * @returns {object} Métodos y estados para el manejo del scanner
 */
export const useQrScanner = () => {
  const { t } = useTranslation();
  const [openQrModal, setOpenQrModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [startScanning, setStartScanning] = useState(false);

  const handleOpenQrScan = useCallback((row, workflow) => {
    setSelectedRow({row, workflow});
    setOpenQrModal(true);
    setStartScanning(false);
  }, []);

  const handleCloseQrModal = useCallback(() => {
    setOpenQrModal(false);
    setSelectedRow(null);
    setStartScanning(false);
  }, []);

  const handleStartScanning = useCallback(() => {
    setStartScanning(true);
  }, []);

  const handleQrScan = useCallback(async (result, onScanSuccess, validator) => {
    if (!result?.equipmentCode && result?.type !== 'workflow') {
      toast.error(t("qrScanner.errors.readError"));
      return;
    }

    // Si se proporciona un validador personalizado, usarlo
    if (validator) {
      try {
        const isValid = await validator(result, selectedRow?.row);
        if (isValid) {
          if (onScanSuccess) {
            onScanSuccess({ ...selectedRow, qrData: result });
          }
        }
      } catch (error) {
        toast.error(t("qrScanner.errors.validationError"));
      }
      return;
    }
  }, [selectedRow]);

  const handleQrError = useCallback((error) => {
    toast.error(t("qrScanner.errors.scanError"));
  }, [t]);

  return {
    openQrModal,
    selectedRow,
    startScanning,
    handleOpenQrScan,
    handleCloseQrModal,
    handleStartScanning,
    handleQrScan,
    handleQrError
  };
};
